<div class="dev-panel">
  <div class="dev-panel-header">
    <span>🛠 Dev Login Seeder</span>
    <button type="button" aria-label="Toggle" (click)="toggleCollapse()">{{ collapsed ? '+' : '−' }}</button>
  </div>
  @if (!collapsed) {
    <div class="dev-panel-body">
      <div class="dev-panel-row">
        <div>
          <label for="dev-panel-first-name">First Name</label>
          <input id="dev-panel-first-name" type="text" [(ngModel)]="form.firstName" />
        </div>
        <div>
          <label for="dev-panel-last-name">Last Name</label>
          <input id="dev-panel-last-name" type="text" [(ngModel)]="form.lastName" />
        </div>
      </div>
      <div>
        <label for="dev-panel-email">Email</label>
        <input id="dev-panel-email" type="email" [(ngModel)]="form.email" />
      </div>
      <div>
        <label for="dev-panel-password">Password</label>
        <input id="dev-panel-password" type="password" [(ngModel)]="form.password" />
      </div>
      <div>
        <label for="dev-panel-user-type">User Type</label>
        <select id="dev-panel-user-type" [(ngModel)]="form.userType" (ngModelChange)="onUserTypeChange()">
          <option value="IchraXUser">IchraXUser</option>
          <option value="TradingPartnerUser">TradingPartnerUser</option>
          <option value="VendorUser">VendorUser</option>
        </select>
      </div>
      @if (form.userType === 'TradingPartnerUser') {
        <div>
          <label for="dev-panel-trading-partner">Trading Partner</label>
          <select id="dev-panel-trading-partner" [(ngModel)]="form.tradingPartnerID">
            @for (tp of tradingPartners; track tp.tradingPartnerID) {
              <option [value]="tp.tradingPartnerID">{{ tp.name }} (ID: {{ tp.tradingPartnerID }})</option>
            }
          </select>
        </div>
      }
      @if (form.userType === 'VendorUser') {
        <div>
          <label for="dev-panel-vendor">Vendor</label>
          <select id="dev-panel-vendor" [(ngModel)]="form.vendorID">
            @for (v of vendors; track v.vendorID) {
              <option [value]="v.vendorID">{{ v.name }} (ID: {{ v.vendorID }})</option>
            }
          </select>
        </div>
      }
      <button class="dev-panel-seed-btn" type="button" (click)="seed()" [disabled]="loading">
        {{ loading ? 'Seeding…' : 'Seed & Sign In' }}
      </button>
      <div class="dev-panel-result" [class.dev-panel-error]="resultIsError">{{ resultMessage }}</div>
      <hr>
      <div class="dev-panel-header" style="cursor:default">🔑 Reset Password</div>
      <div>
        <label for="dev-panel-reset-email">Email</label>
        <input id="dev-panel-reset-email" type="email" [(ngModel)]="resetForm.email" />
      </div>
      <div>
        <label for="dev-panel-reset-new-password">New Password</label>
        <input id="dev-panel-reset-new-password" type="password" [(ngModel)]="resetForm.newPassword" />
      </div>
      <button class="dev-panel-seed-btn" type="button" (click)="resetPassword()" [disabled]="resetLoading">
        {{ resetLoading ? 'Resetting…' : 'Reset Password' }}
      </button>
      <div class="dev-panel-result" [class.dev-panel-error]="resetResultIsError">{{ resetResultMessage }}</div>
    </div>
  }
</div>
